export default function Checkbox({
    disabled,
    onChange,
    className,
    checked,
}: {
    disabled?: boolean;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    className?: string;
    checked?: boolean;
}) {
    return (
        <div className="form-control">
            <input
                type="checkbox"
                className={`${className} checkbox border-oxford-blue bg-slate-blue`}
                onChange={onChange}
                checked={checked}
                disabled={disabled}
            />
        </div>
    );
}
